import { requst } from '../config'

// 日历上数据
export const getPermitCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/permit/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &projectId=${params.projectId}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getPermitDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 根据日期查询当天数据
export const getPermitByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/permit/getByDate?
            produceDate=${params.produceDate}
            &projectId=${params.projectId}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 保存数据
export const postPermitDataApi = activityData => {
    const url = `/permit/save`
    return requst.post(url, activityData)
}
